import { render, staticRenderFns } from "./PASI.vue?vue&type=template&id=dc285c4c&"
import script from "./PASI.vue?vue&type=script&lang=js&"
export * from "./PASI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports